import { combineReducers } from "redux";
import auth from "./auth/authReducer";
import file from "./home/fileUploadReducer";
import home from "./home/homeReducer";
import company from "./company/companyReducer";
import business from "./business/businessReducer";
import bankStatement from "./bankStatement/bankStatementReducer";
import dataTable from "./dataTable";

export default combineReducers({
  auth,
  file,
  home,
  company,
  business,
  bankStatement,
  dataTable,
});
